import connect from 'react-redux/es/connect/connect';

import {
    addActivityToCompareList,
    removeActivityFromCompareList,
    clearCompareList
} from '../actions/compareActivities';
import CompareActivitiesPage from '../pages/compareactivities';

const mapStateToProps = state => ({
    isAgent: state.user.user?.role === 'agent',
    isAdmin: state.user.user?.role === 'admin'
});

const mapDispatchToProps = dispatch => ({
    addActivityToCompareList: activity => {
        dispatch(addActivityToCompareList(activity));
    },
    removeActivityFromCompareList: activityId => {
        dispatch(removeActivityFromCompareList(activityId));
    },
    clearCompareList: () => {
        dispatch(clearCompareList());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(CompareActivitiesPage);
